/**
 * Migrates brand sections to include the new Moodboard Gallery section
 * This ensures existing brands get the new section added after photography-cover
 */

export const migrateMoodboardGallerySection = (sections: any[]): any[] => {
  // Check if moodboard-gallery section already exists
  const hasMoodboardGallery = sections.some(section => section.id === 'moodboard-gallery');

  if (hasMoodboardGallery) {
    return sections; // Already has the section, no migration needed
  }

  // Find the index of photography-cover section
  const photographyCoverIndex = sections.findIndex(section => section.id === 'photography-cover');

  if (photographyCoverIndex === -1) {
    return sections; // No photography-cover section found, skip migration
  }

  // Create the new moodboard-gallery section
  const moodboardGallerySection = {
    id: 'moodboard-gallery',
    title: 'Moodboard Gallery',
    content: {
      galleryTitle: 'Moodboard',
      galleryImages: JSON.stringify([])
    },
    styles: {
      backgroundColor: '#FFFFFF',
      textColor: '#333942',
      fontFamily: 'Helvetica',
      fontSize: '16px',
      padding: '60px',
      position: 'relative'
    },
    customization: {
      backgroundType: 'color',
      backgroundColor: '#FFFFFF',
      backgroundImage: '',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      overlayEnabled: false,
      overlayColor: '#000000',
      overlayOpacity: 0,
      overlayBlendMode: 'normal'
    }
  };

  // Insert the new section right after photography-cover
  const newSections = [
    ...sections.slice(0, photographyCoverIndex + 1),
    moodboardGallerySection,
    ...sections.slice(photographyCoverIndex + 1)
  ];

  return newSections;
};
